// extracted by mini-css-extract-plugin
module.exports = {"recommendations__item":"Recomendations_recommendations__item__LI7Ma","recomendations__title":"Recomendations_recomendations__title__qxhnM"};